import React, { useEffect } from 'react';
import { Routes, Route, useNavigate} from 'react-router-dom';
import Home from './container/Home';
import Login from './components/Login';
import { userQuery } from './utils/data';

const App = () => {
  const navigate = useNavigate();

  useEffect(() =>{ 
    const user = userQuery();
    if (!user) navigate('/login');
  },[])
  
  return (
    <Routes>
      <Route path = 'login' element = {<Login/>} />
      <Route path = '/*' element = {<Home />} />
    </Routes>
  )
}

export default App